import { useParams } from 'react-router-dom';

import {
  GetMenuCustomizationDocument,
  useUpdateWebCustomizationSettingsV2Mutation,
  UpdateWebCustomizationSettingsV2MutationHookResult,
  useUpdateEnterpriseWebCustomizationSettingsV2Mutation,
  UpdateEnterpriseWebCustomizationSettingsV2MutationHookResult,
} from 'types/graphql';

import { useStores } from 'src/hooks/use-stores';

export function useUpdateWebCustomizationSettingsV2(): UpdateWebCustomizationSettingsV2MutationHookResult[0] {
  const { id: dispensaryId } = useParams<{ id: string }>();
  const { apolloClient } = useStores();

  const [handleUpdate] = useUpdateWebCustomizationSettingsV2Mutation({
    client: apolloClient,
    refetchQueries: [
      {
        query: GetMenuCustomizationDocument,
        variables: {
          dispensaryId,
        },
      },
    ],
  });

  return handleUpdate;
}

export function useUpdateEnterpriseWebCustomizationSettingsV2(): UpdateEnterpriseWebCustomizationSettingsV2MutationHookResult[0] {
  const { id: dispensaryId } = useParams<{ id: string }>();
  const { apolloClient } = useStores();

  const [handleUpdate] = useUpdateEnterpriseWebCustomizationSettingsV2Mutation({
    client: apolloClient,
    refetchQueries: [
      {
        query: GetMenuCustomizationDocument,
        variables: {
          dispensaryId,
        },
      },
    ],
  });

  return handleUpdate;
}
